import { render, staticRenderFns } from "./list.vue?vue&type=template&id=648ab46d&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648ab46d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('648ab46d')) {
      api.createRecord('648ab46d', component.options)
    } else {
      api.reload('648ab46d', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=648ab46d&scoped=true", function () {
      api.rerender('648ab46d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/platformManagement/routeManagement/richText/list.vue"
export default component.exports